module.exports = __webpack_public_path__ + "static/media/Partner15.22924e8d.webp";